import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=d71f4d2e&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=d71f4d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71f4d2e",
  null
  
)

export default component.exports